import { ReactElement } from 'react';

import { HeaderW, PageTitle, TitleAccent } from './styled';

interface PageHeaderProps {
  pageTitle: ReactElement | string;
}

export function PageHeader({ pageTitle }: PageHeaderProps): ReactElement {
  const renderTitle = () => {
    if (typeof pageTitle !== 'string' || !pageTitle.includes('\n')) {
      return pageTitle;
    }
    const [first, ...rest] = pageTitle.split('\n');
    return (
      <>
        {first} <TitleAccent>{rest.join('\n')}</TitleAccent>
      </>
    );
  };

  return (
    <HeaderW>
      <PageTitle variant="h6">{renderTitle()}</PageTitle>
    </HeaderW>
  );
}
